import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';

const FragranceSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$fragranceSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$fragrance' });

  return (
    <section className="base-section fragrance-section">
      <div className="branding-hero">
        <a
          className="fragrance-product-wrap hover-btn-animation"
          href={tLink('fragrance')}
          id="HP_fragrance_fragrance-set"
        >
          <picture>
            <source
              srcSet="/images/homePage/fragranceSection/sheu-fragrance-mob.webp"
              media="(max-width: 660px)"
            />
            <img
              src="/images/homePage/fragranceSection/sheu-fragrance.webp"
              alt={t('fragrance')}
              width={755}
              height={787}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <div className="text-block">
            <div className="text-block-content">
              <h2>{t('fragrance')}</h2>
              <p className="mobile-viewport">{t('description')}</p>
              <Button
                className="base-btn bg-red"
                noTabbing
                ariaLabel={`${tButton('shopNow')}: ${t('fragrance')}`}
              >
                {tButton('shopNow')}
              </Button>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default FragranceSection;
